import { useState } from 'react';
import { updatePassword } from '../services/api';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [passwordMismatch, setPasswordMismatch] = useState(false);

  const authToken = localStorage.getItem('authToken');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === 'new_password' || name === 'confirm_password') {
      setPasswordMismatch(
        name === 'new_password'
          ? value !== formData.confirm_password && formData.confirm_password !== ''
          : formData.new_password !== value && value !== ''
      );
    }
  };

  const isFormValid = () => {
    return (
      formData.current_password &&
      formData.new_password &&
      formData.confirm_password &&
      formData.new_password === formData.confirm_password
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!authToken) {
      setError('Authentication token is missing. Please log in again.');
      return;
    }

    if (passwordMismatch) {
      setError('New passwords do not match.');
      return;
    }

    try {
      const response = await updatePassword(authToken, {
        current_password: formData.current_password,
        new_password: formData.new_password,
      });
      console.log(response)
      setMessage(response.message || 'Password updated successfully.');
      setFormData({
        current_password: '',
        new_password: '',
        confirm_password: '',
      });
      setPasswordMismatch(false);
    } catch (err) {
      console.error('Error response:', err.response); // Log full error response
      setError(err.response?.data?.error || JSON.stringify(err.response?.data) || 'An error occurred.');
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-sm mt-10">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
        Change Password
      </h2>
      {message && (
        <p className="text-green-600 bg-green-100 p-3 rounded-md mb-4 text-center">
          {message}
        </p>
      )}
      {error && (
        <p className="text-red-600 bg-red-100 p-3 rounded-md mb-4 text-center">
          {error}
        </p>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="current_password"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Current Password
          </label>
          <input
            type="password"
            id="current_password"
            name="current_password"
            value={formData.current_password}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-border rounded-md focus:ring-2 focus:ring-text-primary focus:border-text-primary"
            placeholder="Enter current password"
          />
        </div>
        <div>
          <label
            htmlFor="new_password"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            New Password
          </label>
          <input
            type="password"
            id="new_password"
            name="new_password"
            value={formData.new_password}
            onChange={handleChange}
            required
            className={`w-full px-4 py-2 border ${
              passwordMismatch ? "border-red-500" : "border-border"
            } rounded-md focus:ring-2 focus:ring-text-primary focus:border-text-primary`}
            placeholder="Enter new password"
          />
        </div>
        <div>
          <label
            htmlFor="confirm_password"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Confirm New Password
          </label>
          <input
            type="password"
            id="confirm_password"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleChange}
            required
            className={`w-full px-4 py-2 border ${
              passwordMismatch ? "border-red-500" : "border-border"
            } rounded-md focus:ring-2 focus:ring-text-primary focus:border-text-primary`}
            placeholder="Confirm new password"
          />
          {passwordMismatch && (
            <p className="text-red-500 text-sm mt-1">Passwords do not match.</p>
          )}
        </div>
        <button
          type="submit"
          disabled={!isFormValid()}
          className={`w-full py-2 px-4 rounded-md text-white font-medium ${
            isFormValid()
              ? "bg-secondary hover:bg-secondary/90/85 focus:ring-2 focus:ring-text-primary focus:ring-offset-2"
              : "bg-gray-400 cursor-not-allowed"
          } transition duration-200`}
        >
          Change Password
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;